import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AOSError } from 'src/app/enums/aos-error';
import { PartnerType } from 'src/app/enums/partner-type';
import { AosService } from '../../services/aos.service';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {

  partnerTypes: any[] = [];
  countries: any[] = [];
  installationCategories: any[] = [];
  isSubmitLoading = false;
  data: any = {};
  errorMsg = '';
  successMsg = '';


  @ViewChild('f') form: NgForm;

  constructor(private dataService: DataService, private aosService: AosService) { 
    this.partnerTypes = [
      {name: 'Partner', value: PartnerType.Partner},
      {name: 'Distributor', value: PartnerType.Distributor},
      {name: 'Reseller', value: PartnerType.Reseller},
      {name: 'Hotel Chain', value: PartnerType.Hotel_Chain},
    ]
  }

  async ngOnInit() {
    await this.FetchCountries();

    await this.FetchInstallationCategories();
    
    this.dataService.hideFooter.next(true);
  }

  async FetchCountries() {
    this.aosService.FetchCountries().subscribe(async (response: any[]) => {
      this.countries = response;
    },async (err) => {
      if(err.status == 401) {
        await this.aosService.LoginPartnerUser();
        this.FetchCountries();
      }
    })
  }
  async FetchInstallationCategories() {
    this.aosService.FetchInstallationCategories().subscribe(async (response: any[]) => {
      this.installationCategories = response;
    },async (err) => {
      if(err.status == 401) {
        await this.aosService.LoginPartnerUser();
        this.FetchInstallationCategories();
      }
    })
  }

  async onSubmit() {
    this.errorMsg = '';
    this.successMsg = '';
    this.data.installationCategoriesId = [this.data.installationCategoryID];
    
    if(this.data._Password != this.data._PasswordRepeat) {
      this.errorMsg = 'Password do not match'
      return;
    }
    this.isSubmitLoading = true;
    
    this.aosService.CreatePartnerFromLandingPage(this.data).subscribe(async (response: any[]) => {
      
      this.isSubmitLoading = false;
      this.form.reset();
      this.data = {};
      this.successMsg = 'Partner registered successfully, a confirmation has been sent to your email';
    },async (err) => {
      console.log('error', err)
      if(err.status == 401) {
        await this.aosService.LoginPartnerUser();
        this.onSubmit();
      }
      else if (err.error._ErrorCode == AOSError.LICENSE_CODE_NOT_FOUND) {
        this.errorMsg = 'License Code not found';
        this.isSubmitLoading = false;
      }
      else {
        this.isSubmitLoading = false;
        if(err.error._ErrorCode == AOSError.EXISTS) {
          this.errorMsg = 'Email Exists';
        }else {
          this.errorMsg = 'Something went wrong';
        }
      }
    })
  }

}
